import { IconButton, Tooltip } from "@material-ui/core";
import React from "react";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import { eventLabelGroupsConstants } from "../../../constants/eventLabelGroups.contansts";
import SendIcon from "@material-ui/icons/Send";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import { ChatEmojiPicker } from "./ChatEmojiPicker";
import VideocamRoundedIcon from "@material-ui/icons/VideocamRounded";

export function MessageTools(props) {
  /*   const [click, setClick] = React.useState(false);
  if (click) throw new Error("TEST"); */
  const { text, sendButtonColor, sendMessage, primaryColor, preview, allowChatVideoCall = true, currentChat } = props;
  return (
    <div className="text-bar__thumb" style={{ display: "flex", justifyContent: "flex-end" }}>
      <ChatEmojiPicker {...props} />
      <IconButton disabled={!text || preview} style={{ color: sendButtonColor, padding: "8px" }} onClick={() => sendMessage()}>
        <Tooltip title={<EventLabel2 name="SendMessageToolTip" groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />}>
          <SendIcon />
        </Tooltip>
      </IconButton>
      <IconButton
        disabled={preview}
        style={{ padding: "8px" }}
        onClick={() => {
          sendMessage("THUMB_UP");
        }}
      >
        <Tooltip title={<EventLabel2 name="ThumbUpToolTip" groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />}>
          <ThumbUpIcon style={{ color: primaryColor }} />
        </Tooltip>
      </IconButton>
      {currentChat != "ALL"  && currentChat != "BACKSTAGE"? (
        <IconButton
          disabled={preview}
          style={{ padding: "8px" }}
          onClick={() => {
            sendMessage("VIDEO_CALL_INVITATION");
          }}
        >
          <Tooltip title={<EventLabel2 name="SendVideoInvitationTooltip" groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />}>
            <VideocamRoundedIcon style={{ color: primaryColor }} />
          </Tooltip>
        </IconButton>
      ) : null}
    </div>
  );
}
